import classNames from "classnames";
import React from "react";

import SingleValueFilterAbstract from "../../../../../../../abstract/SingleValueFilterAbstract";
import withTranslations from "../../../../../../../hocs/withTranslations";
import TrendStatusHelper from "../../../../../../../lib/UniversalTable/RendererHelpers/TrendStatusHelper";
import normalizeFilterValues from "../../../../../../../lib/UniversalTable/CoreHelpers/normalizeFilterValues";
import { TrendStatusArrows } from "../../TrendStatusArrows/TrendStatusArrows";
import "../../../../../../../lib/Checkbox/Checkbox.scss";

@withTranslations
class TrendStatusCheckboxFilter extends SingleValueFilterAbstract {
  toggleOption(optionValue) {
    const { onChange, value, disabled } = this.props;

    if (disabled) {
      return;
    }

    const selectedValues = normalizeFilterValues(value);

    const nextValues = selectedValues.includes(optionValue)
      ? selectedValues.filter(item => item !== optionValue)
      : [...selectedValues, optionValue];

    onChange(nextValues);
  }

  render() {
    const { column, value, translate } = this.props;
    const options = this.mapOptionsList(column.filter_data, {
      labelPrefix: "trend_status_",
      isRuleset: true
    });
    const selectedValues = normalizeFilterValues(value);

    return (
      <div className="filters-item-wrapper trend-status-checkbox-filter">
        <span className="trend-status-checkbox-filter__label">
          {translate(column.label)}
        </span>
        <div className="trend-status-checkbox-filter__options">
          {options.map(option => {
            const checked = selectedValues.includes(option.value);
            const arrows = TrendStatusHelper.render(option.value);

            return (
              <button
                key={option.value}
                type="button"
                className="lp_checkbox font-medium text-sm py-1 flex gap-2 px-0 text-black text-left trend-status-checkbox-filter__option"
                onClick={() => {
                  this.toggleOption(option.value);
                }}
              >
                <div
                  className={classNames("check", {
                    check_checked: checked,
                    check_unchecked: !checked
                  })}
                />
                <span className="trend-status-checkbox-filter__option-content">
                  <span>{option.label}</span>
                  {arrows ? <TrendStatusArrows arrows={arrows} /> : null}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}

export default TrendStatusCheckboxFilter;
